var _rect, _rect2, _rect3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontsidePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 147,
    viewBox: "0 0 271 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 13,
    width: 173,
    height: 20,
    rx: 8,
    fill: "#E6E8EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 53,
    width: 173,
    height: 20,
    rx: 8,
    fill: "#E6E8EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 102,
    width: 271,
    height: 45,
    rx: 8,
    fill: "#E6E8EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.9416C0 83.2241 16.7859 86.6668 36.6667 86.6668C56.442 86.6668 73.3333 83.3462 73.3333 70.0588C73.3333 56.7762 56.552 53.3335 36.6667 53.3335C16.8913 53.3335 0 56.6541 0 69.9416Z",
    fill: "#E6E8EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6668 46.6667C49.621 46.6667 60.0002 36.2821 60.0002 23.3311C60.0002 10.3802 49.621 0 36.6668 0C23.7171 0 13.3335 10.3802 13.3335 23.3311C13.3335 36.2821 23.7171 46.6667 36.6668 46.6667Z",
    fill: "#E6E8EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontsidePlaceholder);
export default __webpack_public_path__ + "static/media/frontside-placeholder.3dd6fc19bfcc1382ad813934c892ad06.svg";
export { ForwardRef as ReactComponent };